import Axios from 'axios'

const wpApiHost = document.getElementById('root_calculator').getAttribute('data-api')
const wpApiUrl = wpApiHost + 'mfcu/v1/calc/'

const Api = {

  getVariables () {
    return Axios.get(wpApiUrl + 'variables')
      .then((response) => {
        return JSON.parse(response.data)
      }, (error) => {
        window.console.log('error of retrieving variables ')
        window.console.log(error)
      })
  },

  requestQuote (data) {
    let params = {
      quote_monthly_repayment: data.mrepay,
      quote_apr: data.apr,
      quote_member: data.member,
      quote_total_credit: data.tcredit,
      quote_total_repay: data.trepay,
      quote_purpose: data.purpose,
      quote_id: data.id,
    }

    return Axios.post(wpApiUrl + 'quote', params)
      .then((response) => {
        return JSON.parse(response.data)
      }, (error) => {
        window.console.log('quote error')
        window.console.log(error)
      })
  },
}

export default Api
